import { Ref } from "react";

import { DDQForm, FormConfig } from "../types";
import FormSection, { Mode } from "./FormSection";

export type Props = {
  register?: () => Ref<any>;
  mode: Mode;
  form: DDQForm;
};

export default function SanctionsAndMonitoringFormSection({ register, mode, form }: Props) {
  const formConfig: FormConfig = {
    hasPhysicalPresence: {
      type: "boolean",
      label:
        "6A. Does the entity have a physical presence (e.g., branches, subsidiaries or representative offices) in countries / regions against which UN, OFAC, OFSI, EU and G7 member countries have enacted comprehensive jurisdiction-based sanctions?",
    },
    hasOffshoreCustomers: {
      type: "boolean",
      label:
        "6B. Does the entity have offshore customers domiciled in countries / regions against which UN, OFAC, OFSI, EU and G7 member countries have enacted comprehensive jurisdiction-based sanctions?",
    },
    riskBasedApproach: {
      type: "boolean",
      label:
        "6C. Does the Entity have a risk-based approach to screening customers and connected parties to determine whether they are PEPs, or controlled by PEPs?",
    },
    screeningCustomers: {
      type: "choice",
      label: "If Yes, when does the PEP screening of customers occur?",
      choices: [
        { label: "Onboarding", value: "onboarding" },
        { label: "KYC Refresh / Periodic Review Event Driven Review ", value: "kycRefresh" },
        { label: "Continuously", value: "continuously" },
      ],
    },
    screeningMethod: {
      type: "choice",
      label: "6D. Please indicate the method used by the Entity to screen PEPs?",
      choices: [
        { label: "Manual", value: "manual" },
        { label: "Automated", value: "automated" },
        { label: "Combination of Automated and Manual", value: "manualAndAutomated" },
      ],
    },
    entityHasPolicies: {
      type: "boolean",
      label:
        "6E. Does the Entity have policies, procedures and processes to review and escalate potential hits from screening customers and connected parties to determine whether they are PEPs, or controlled by PEPs?",
    },
    screensCustomers: {
      type: "boolean",
      label:
        "6F. Does the Entity screen its customers, including beneficial ownership information collected by the Entity, during onboarding and regularly thereafter against Sanctions Listsv?",
    },
    screensCustomersExplain: {
      type: "choice",
      label: "If yes, Please indicate the method used by the Entity",
      choices: [
        { label: "Manual", value: "manual" },
        { label: "Automated", value: "automated" },
        { label: "Combination of Automated and Manual", value: "manualAndAutomated" },
      ],
    },
    sactionsLists: {
      type: "multipleChoice",
      label: "6G. Please select the Sanctions Lists used by the Entity in its sanctions screening processes",
      choices: [
        { label: "Consolidated United Nations Security Council Sanctions List (UN)", value: "un" },
        { label: "United States Department of the Treasury's Office of Foreign Assets Control (OFAC)", value: "ofac" },
        { label: "Office of Financial Sanctions Implementation HMT (OFSI)", value: "ofsi" },
        { label: "European Union Consolidated List (EU)", value: "eu" },
        { label: "Lists maintained by other G7 member countries", value: "g7" },
      ],
    },
    sanctionsListExplain: {
      type: "text",
      label: "If other, please specify",
    },
    reportsSuspiciousActivity: {
      type: "text",
      label:
        "6H. Does the Entity have risk-based policies, procedures and monitoring processes for the identification and reporting of suspicious activity?",
    },
    method: {
      type: "choice",
      label: "If yes, Please indicate the method used by the Entity",
      choices: [
        { label: "Manual", value: "manual" },
        { label: "Automated", value: "automated" },
        { label: "Combination of Automated and Manual", value: "manualAndAutomated" },
      ],
    },
  };

  return (
    <FormSection
      title="Section 6. Sanctions, screening and Transaction monitoring"
      formConfig={formConfig}
      register={register}
      mode={mode}
      form={form}
    />
  );
}
